import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

export type AlertType = 'INFO' | 'WARN' | 'ERROR' ;

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [NgIf, ],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent {

  @Input()
  type?: AlertType ;

  public get alertClass(): string | undefined {

    if (!this.type)
      return undefined ;

    switch (this.type) {
      case 'INFO':
        return 'alert-info';
      case 'WARN': 
        return 'alert-warn' ;
      case 'ERROR':
        return 'alert-error';
    }
  }

}
